export const SET_ACTIVE_SEARCH_PARAMETERS = 'SET_ACTIVE_SEARCH_PARAMETERS'

export const setActiveSearchParameters = payload => ({
  type: SET_ACTIVE_SEARCH_PARAMETERS,
  payload
})
